Ext.define('SA.Predicate', {
    singleton: true,

    and(predicates) {
        return this.compound({operator: 'and', predicates});
    },

    compound({operator, predicates}) {
        var predicates = predicates.filter(predicate => !predicate.isNullPredicate());

        if (predicates.length === 0) {
            return new SA.NullPredicate();
        }

        return (operator === 'and') ? new SA.AndPredicate(predicates) : new SA.OrPredicate(predicates);
    },

    create([operator, ...operands]) {
        if (operator === 'and') {
            return this.compound({operator, predicates: operands});
        }
        else if (operator === 'or') {
            return this.compound({operator, predicates: operands});
        }

        return new SA.AtomPredicate({operator, operands});
    },

    equal(field, value) {
        return this.create(['=', field, value]);
    },

    gte(field, value) {
        return this.create(['>=', field, value]);
    },

    lte(field, value) {
        return this.create(['<=', field, value]);
    },

    notNull(field) {
        return this.create(['<>', field, null]);
    },

    withinOrRadius({location, geoUnitId}) {
        if (location.isSeries()) {
            return this.create(['within', location.getId()]);
        }
        else if (location.isCombo()) {
            return this.create(['within', ...location.getConstituentIds()]);
        }

        return this.create(['radius', geoUnitId, location.getRadiusSizeInMeters(), location.getCenterLocationId()]);
    }
});